import '../../style/scss/App.scss';

export default function PackageItemListItem(props) {
  const item = props.value || {};
  const onValueChange = (e) => {
    props.onChange(e.target.value, item.Description, item.ItemTypeID, e);
  };
  const onChangeDescription = (e) => {
    props.onChange(item.Value, e.target.value, item.ItemTypeID, e);
  };
  const toggleEnabled = () => {
    props.onToggleEnabled(item.ItemTypeID);
  };
  return (
    <div className="Role mobilePanel packageListItem">
      <span className="leftItem">
        <input
          type="checkbox"
          checked={!!item.Enabled}
          onChange={toggleEnabled}
          aria-label={`Enable ${item.ItemTypeName || item.Text || 'item'}`}
        />
      </span>
      <span className="middle">
        <span className="title" onClick={toggleEnabled}>
          {item.ItemTypeName || item.Text}
        </span>
        <span className="byline" onClick={toggleEnabled}>
          {item.TypeDescription}
        </span>
        <span className={"description" + (item.Enabled ? "" : " hidden")}>
          <textarea
            rows={2}
            value={item.Description || ""}
            onChange={onChangeDescription}
            className="packageItemDescription"
            placeholder="Employer specific description"
          />
        </span>
      </span>
      <span className={"rightText" + (item.Enabled && item.DataType !== 4 ? "" : " hidden")}>
        <input type="text" value={item.Value || ""} onChange={onValueChange} />
      </span>
    </div>
  );
}
